<template>
    <div>
        <div v-if="type == 'loading'" style="top: 50%;margin-top: -21px;width: 100%;text-align: center;position: absolute;">
            <img src="./assets/loading.svg" width="48px" height="48px" alt="" />
            <p style="color: #A4A9B3;margin: 5px 0;font-size: 14px;">{{msg}}</p>
        </div>
        <div v-else-if="type == 'linkfail'" style="top: 50%;margin-top: -21px;width: 100%;text-align: center;position: absolute;">
            <img src="./assets/linkfail.svg" width="48px" height="48px" alt="" />
            <p style="color: #A4A9B3;margin: 5px 0;font-size: 14px;">{{ msg }}</p>
        </div>
        <div v-else-if="type == 'videoinit'" style="top: 50%;margin-top: -21px;width: 100%;text-align: center;position: absolute;">
            <img src="./assets/videoinit.svg" width="48px" height="48px" alt="" />
            <p style="color: #A4A9B3;margin: 5px 0;font-size: 14px;">{{ msg }}</p>
        </div>
        <div v-else style="top: 50%;margin-top: -21px;width: 100%;text-align: center;position: absolute;">
            <img src="./assets/closelink.svg" width="48px" height="48px" alt="" />
            <p style="color: #A4A9B3;margin: 5px 0;font-size: 14px;">{{ msg }}</p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            type: 'videoinit',
            msg: '未映射',
        };
    },
    methods: {}
};
</script>

<style></style>
